<template>
  <div class="bg">
    <!-- <div class="header">
      <img src="@/assets/logo.png" alt="">
    </div> -->
    <div class="login-form">
      <p class="title">用户登录</p>
      <div>
        <div class="item">
            <p>姓名</p>
            <p><el-input v-model="form.name" placeholder="请输入您的姓名" @keyup.enter="login"></el-input></p>
        </div>
        <div class="item">
            <p>手机号</p>
            <p><el-input v-model="form.mobile" placeholder="请输入您的手机号" @keyup.enter="login"></el-input></p>
        </div>
        <div class="btn item" @click="login"><span>登录</span></div>
      </div>
      <!-- <el-form :model="form" size="large" label-position="left" label-width="70px">
        <el-form-item label="姓&nbsp;&nbsp;&nbsp;名">
          <el-input v-model="form.name" placeholder="请输入您的姓名" @keyup.enter="login"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" placeholder="请输入您的手机号" @keyup.enter="login"></el-input>
        </el-form-item>
        <el-button type="primary" :disabled="loginBtnDisabled" @click="login"  style="width: 100%"
                   :auto-insert-space="true">登录
        </el-button>
      </el-form> -->
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
import { useRouter } from "vue-router";
import { reactive, computed } from "vue";
import { ElMessage } from "element-plus";


const form = reactive({
  name: "",
  mobile: ""
});

const loginBtnDisabled = computed(() => {
  return !form.name || !form.mobile;
});

const userStore = useUserStore();
const router = useRouter();

// 如果已经登录，直接跳转到患者列表页
// if (userStore.isLogin) {
//   router.push({ name: "patients" });
// }
// // 额外防止缩放的双保险
// document.addEventListener('touchstart', function(event) {
//     if (event.touches.length > 1) {
//         event.preventDefault();
//     }
// }, { passive: false });

// document.addEventListener('gesturestart', function(event) {
//     event.preventDefault();
// });
const login = async () => {
  const res = await userStore.loginapp(form.name, form.mobile);
  console.log(res,"登录成功")
  if (res.result == 'success') {
    router.push({ name: "patientsApp" });
    ElMessage({
      message: "登录成功",
      type: "success"
    });
  } else {
    // 登录失败
    ElMessage({
      message:res.msg,
      type: "error"
    });
  }
};
</script>

<style scoped lang="scss">
.bg {
  height: 100vh;
  width: 100vw;
  background: rgb(76, 130, 212);
}

.header {
  background: #D84357;
  height: 40vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  color: #ffffff;

}

.login-form {
  padding: 30px 30px 40px 30px;
  border-radius: 10px;
  box-shadow: #a2a2a2 0px 0px 10px 0px;
  width: 70vw;
  max-width: 300px;
  background: #ffffff;
  position: absolute;
  top: 30vh;
  left: 0;
  right: 0;
  margin: 0 auto;
  .title{
    font-size: 24px;
    text-align: center;
  }
  .item{
    display: flex;
    height: 60px;
    align-items: center;
    p:nth-child(1){
      width: 60px;
    }
    p:nth-child(2){
      flex: 1;
    
    }
  }
  .btn{
    justify-content: center;
    
    span{
        // padding: 5px 20px;
        height: 30px;
        line-height: 30px;
        color: #ffffff;
        text-align: center;
        width: 100%;
        border-radius: 4px;

        background-color: rgb(57, 81, 201);
    }
  }
}
</style>
